import React, { FC, useState } from 'react';

import Slider from '@material-ui/lab/Slider';

import Input from '../../Input';
import { HandicapAllowanceStyled } from './HandicapAllowance.Styles';

interface IProps {
  defaultValue: number;
  onChange: (value: number) => void;
}

const HandicapAllowance: FC<IProps> = props => {
  const { defaultValue, onChange } = props;

  const [value, setValue] = useState(defaultValue);

  const onSliderChange = (_: any, newValue: number) => {
    setValue(newValue);
  };

  const onSliderComplete = (_: any) => {
    onChange(value);
  };

  const onInputChange = ({ target: { value: newValue } }: any) => {
    setValue(newValue);
    onChange(Number(value));
  };

  return (
    <HandicapAllowanceStyled>
      <h3 className="general-round-info-section__title general-round-info-section__title--wide override">
        Handicap allowance
      </h3>

      <div className="handicap-header-info">
        All players will play to the following percentage of their calculated course handicap.
      </div>

      <div className="event-handicap-input">
        <Slider
          className="handicap-slider"
          value={value}
          onChange={onSliderChange}
          min={1}
          step={1}
          onDragEnd={onSliderComplete}
        />

        <Input
          id="handicap-number-input"
          label=""
          onChange={onInputChange}
          outlined={true}
          type="number"
          inputProps={{ min: 1, max: 100 }}
          value={String(value)}
          noIcon={true}
          fullWidth={true}
        />
      </div>
    </HandicapAllowanceStyled>
  );
};

export default HandicapAllowance;
